<template>
    <v-dialog v-model="visible" persistent max-width="600">
        <template #activator="scope">
            <slot name="activatorElement" v-bind="scope">
                <v-btn
                    color="primary"
                    :text="$t('components.confirmDialog.activator')"
                    v-on="scope.on"
                    @click="open"
                    v-text="$t('components.confirmDialog.activator')"
                />
            </slot>
        </template>

        <v-card>
            <FocusLock>
                <v-card-title class="headline font-weight-bold mb-2" v-text="$t(title)" />
                <v-card-text v-text="$t(text)" />
                <v-card-actions class="ml-4 mt-0">
                    <v-btn
                        ref="submitButton"
                        color="primary"
                        class="modalbutton mb-3"
                        variant="flat"
                        @click="confirm"
                        v-text="$t('components.confirmdialog.confirm')"
                    />
                    <v-btn class="modalbutton mb-3" variant="flat" @click="visible = false" v-text="$t('components.confirmdialog.cancel')" />
                </v-card-actions>
            </FocusLock>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
import { Component, Prop, Watch, Vue } from 'vue-facing-decorator';

@Component
export default class ConfirmDialog extends Vue {
    @Prop({ required: true, type: String })
    private title!: string;
    @Prop({ required: true, type: String })
    private text!: string;

    private visible = false;

    private confirm() {
        this.visible = false;
        this.$emit('confirm');
    }

    @Watch('visible')
    onConfirmDialogOpen() {
        if (this.visible) {
            //Der Dialog wird nach öffnen ganz fokussiert, daher muss ein kurzes Timeout gesetzt werden, statt $nextTick
            setTimeout(() => {
                (this.$refs.submitButton as any).$el.focus();
            }, 20);
        }
    }

    private open() {
        console.log('changing visibility to true');
        this.visible = true;
    }
}
</script>
